module.exports = " <div class=view-exercises _v-7f7bfd9f=\"\"> <list-layout _v-7f7bfd9f=\"\"> <filters :filters=filters @filter=setFilter v-if=filtersVisible _v-7f7bfd9f=\"\"></filters> <ul _v-7f7bfd9f=\"\"> <list-item size=small v-for=\"e in filteredExercises\" :index=$index :order=e.order :link=getListItemLink(e.id) _v-7f7bfd9f=\"\"> {{e.title}} </list-item> </ul> </list-layout> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7f7bfd9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ExercisesView.vue
// module id = 770
// module chunks = 2